import { withTranslation } from 'react-i18next';
import { Component } from 'react';
import ShowAllItemsModal from './ShowAllItemsModal';

class Tags extends Component {
    constructor(props) {
        super(props);

        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);

        this.onClickShowAll = this.onClickShowAll.bind(this);
        this.shownCount = this.props.shownCount ?? 2;
        this.state = {
            showLess: props.items?.length > this.shownCount,
            data: props.items ?? [],
            isOpenModal: false,
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.items !== this.props.items) {
            this.setState({
                data: this.props.items ?? [],
                showLess: this.props.items?.length > this.shownCount,
            });
        }
    }

    onClickShowAll = () => {
        this.setState({ showLess: false });
    };

    onOpenModal() {
        this.setState({ isOpenModal: true });
    }

    onCloseModal() {
        this.setState({ isOpenModal: false });
    }

    render() {
        const { t } = this.props;
        const { showLess } = this.state;

        const firstOnes = this.state.data.slice(0, this.shownCount);
        const data = showLess ? firstOnes : this.state.data;

        return (
            <>
                <div className={'ai-tracking-prompts-cell'}>
                    {data?.map((state) => (
                        <div key={state} title={state} className="ai-tracking-platform-2 big">
                            {state}
                        </div>
                    ))}
                    {showLess && (
                        <div className="ai-tracking-platform-show-more" onClick={this.onOpenModal}>
                            + {this.state.data.length - firstOnes.length}
                        </div>
                    )}
                </div>
                {this.state.isOpenModal && (
                    <ShowAllItemsModal
                        isOpen={this.state.isOpenModal}
                        onClose={this.onCloseModal}
                        data={this.state.data?.map((item) => ({
                            name: item,
                        }))}
                        placeholder={t('ai_tracking.global.search_platforms')}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(Tags);
